module.exports = __webpack_public_path__ + "static/POCentro_PT2020-7cf3c899c9fea12cfc9d4a18cbba2ddf.svg";